import { useEffect } from "react";

const setTitle = title => {
	document.title = title;
};

const setFavicon = favIconHref => {
	let link =
		document.querySelector('link[rel="shortcut icon"]') ||
		document.querySelector('link[rel="icon"]');

	if (!link) {
		link = document.createElement("link");
		link.id = "favicon";
		link.rel = "shortcut icon";
		document.head.appendChild(link);
	}

	link.href = favIconHref;
};


const useHead = ({ favicon = `/faviconA.ico`, pageName }) => {
	useEffect(() => {
		let title = "";
		if (pageName) {
			title = pageName + " | Aurora Payments";
		} else {
			title = "Aurora Payments";
		}
		setTitle(title);
		setFavicon(favicon);
	});
};

export default useHead;
